import { isAuthenticated } from "services/network/auth";
import * as ActionTypes from "services/state/action-types";

function authPayload() {
  return {
    authenticated: isAuthenticated(),
    verified: true,
    error: false,
  };
}

const AUTH_INITIAL_STATE = {
  authenticated: false,
  loadingAuthenticationStep: false,
  userName: null,
  verified: false,
  error: null,
};

export function auth(state = AUTH_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.LOGIN:
    case ActionTypes.LOGIN_SUCCESS:
      return { ...state, ...authPayload() };

    case ActionTypes.LOGIN_FAIL:
      return {
        ...state,
        error: action.error.response && action.error.response.status === 401,
      };

    case ActionTypes.RESTORE_CREDENTIALS:
      return { ...state, ...authPayload(), userName: action.payload.userName };

    case ActionTypes.AUTHENTICATE:
      return { ...state, loadingAuthenticationStep: true };

    case ActionTypes.AUTHENTICATE_ERROR:
    case ActionTypes.AUTHENTICATION_PROCESSING_END:
      return { ...state, loadingAuthenticationStep: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/auth/reducer.js